import { render, staticRenderFns } from "./UpdatedHome.vue?vue&type=template&id=2464e366&scoped=true"
import script from "./UpdatedHome.vue?vue&type=script&lang=js"
export * from "./UpdatedHome.vue?vue&type=script&lang=js"
import style0 from "./UpdatedHome.vue?vue&type=style&index=0&id=2464e366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464e366",
  null
  
)

export default component.exports